import {combineReducers} from 'redux'

import employees from './employees'
import organisations from './organisations'

export default combineReducers({
  // employees,
  organisations,
})
